import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Store } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/vendor-management')({
    staticData: {
        ui: {
            icon: Store,
            title: 'Vendor management',
            subtitle: 'Configure vendor and supplier settings',
            useTitleForChildren: true,
            menuDescription: 'Configure vendor and supplier settings',
        },
        breadcrumb: {
            title: 'Vendor management',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        modules: ['claim'],
    },
    component: Outlet,
});
